import { render, staticRenderFns } from "./CompanyBack.vue?vue&type=template&id=3354f235&"
import script from "./CompanyBack.vue?vue&type=script&lang=js&"
export * from "./CompanyBack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports